<template>
  <v-navigation-drawer
    v-model="localDrawer"
    app
    :stateless="generating"
    temporary
    right
    :width="600"
    style="max-width: 90vw"
    @input="(val) => ctx.emit('update:drawer', val)"
  >
    <v-card elevation="0">
      <v-card-title class="d-flex justify-end align-center pa-2">
        <v-btn icon @click="closeDrawer" aria-label="閉じる">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
    </v-card>
    <generate-commnet-component
      :type="type"
      :cast_id="cast_id"
      :mode="mode"
      @update:drawer="onDrawerUpdate"
      @set-stateless="setStateless"
      @get_all_cast_data="getAllCastData"
    ></generate-commnet-component>
  </v-navigation-drawer>
</template>

<script>
import {
  reactive,
  toRefs,
  defineComponent,
  watch,
  ref,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import selectItem from "@/common/selectItem";
import { repositoryFactory } from "@/repository/repositoryFactory";
import generateCommnetComponent from "./generateComment.vue";

export default defineComponent({
  components: {
    generateCommnetComponent,
  },
  props: ["type", "cast_id", "drawer", "mode"],
  setup(props, ctx) {
    const localDrawer = ref(props.drawer);
    const generating = ref(false);

    const state = reactive({});

    // props.drawerの変更を監視（親コンポーネントからの変更を反映）
    watch(
      () => props.drawer,
      (val) => {
        localDrawer.value = val;
      }
    );

    // ドロワーが閉じた時
    watch(localDrawer, (val, oldVal) => {
      if (oldVal === true && val === false) {
        ctx.emit("update:drawer", false);
      }
    });

    const closeDrawer = () => {
      localDrawer.value = false;
      ctx.emit("update:drawer", false);
    };

    const onDrawerUpdate = (val) => {
      console.log("onDrawerUpdate called with val:", val);
      localDrawer.value = val;
      ctx.emit("update:drawer", val); // さらに上位にも伝える場合
    };

    const setStateless = (val) => {
      generating.value = val;
    };

    const getAllCastData = async (resolve) => {
      const data = ctx.emit("get_all_cast_data", resolve);
      resolve(data);
    };

    return {
      ctx,
      props,
      setting,
      selectItem,
      localDrawer,
      generating,
      ...toRefs(state),
      closeDrawer,
      onDrawerUpdate,
      setStateless,
      getAllCastData,
    };
  },
});
</script>
